import React, { useState } from "react";
import SplitPane from "react-split-pane";
import NewInvoiceForm from "../forms/NewInvoiceForm";
import {
  dateFrEn,
  downloadExcel,
  error,
  firstDayYear,
  float,
  money,
  nextDate,
  success,
} from "@global/actions";
import { apiSend, getRoute } from "@services/axios";
import TableHeader from "@components/TableHeader";
import { useTranslation } from "react-i18next";
import IToolbar from "@components/IToolbar";
import { InputGroup, Button, Form } from "react-bootstrap";
import { confirm } from "@global/actions";
import { useModal } from "@components/ModalRsuiteContext";
import Swal from "sweetalert2";
import { invoiceHeader, newInvoicetNavItems } from "../configs/module";

const NewInvoice = (props) => {
  const { t } = useTranslation();
  const [total, setTotal] = useState(0);
  const [token, setToken] = useState(null);
  const [rateIds, setRateIds] = useState([]);
  const [initialRateIds, setInitialRateIds] = useState([]);
  const [bookingList, setBookingList] = useState([]);
  const [dataInitial, setDataInitial] = useState([]);
  const [selectedService, setSelectedService] = useState(null);
  const paramUseModal = useModal();
  const [dateFrom, setDateFrom] = useState(firstDayYear());
  const [dateTo, setDateTo] = useState(new Date().toLocaleDateString("fr-FR"));
  const header = invoiceHeader(t);
  const navItems = newInvoicetNavItems(t);

  const onChangeDate = (from, to) => {
    setDateFrom(from);
    setDateTo(to);
  };

  const loadData = async () => {
    window.loader(1);
    const payload = {
      service: selectedService?.value,
      dateType: "created_at",
      dateFrom: dateFrEn(dateFrom),
      dateTo: dateFrEn(dateTo),
    };
    const response = await apiSend(getRoute("INVOICE_NEW"), "post", payload);
    setBookingList(response?.data?.result?.list);
    setDataInitial(response?.data?.result?.list);
    setToken(response?.data?.result?.token);
    setRateIds(response?.data?.result?.rateIds);
    setInitialRateIds(response?.data?.result?.rateIds);

    setTotal(0);
    window.loader(0);
  };

  function refresh() {
    setBookingList(dataInitial);
    setRateIds(initialRateIds);
    setTotal(0);
  }

  function setMaxAmount() {
    var totalAmount = 0;
    var amount = float(document.getElementById("max-amount").value);
    var data = [];
    var obj = [];
    setRateIds(obj);
    dataInitial.forEach(function (item) {
      totalAmount += float(item.amount);
      if (totalAmount <= amount) {
        data.push(item);
        obj.push(item.rate_id);
      } else {
        totalAmount -= float(item.amount);
      }
    });

    setBookingList(data);
    setRateIds(obj);
  }

  const createInvoice = async (params) => {
    const response = await apiSend(
      getRoute("INVOICE_NEW_SAVE"),
      "post",
      params
    );
    if (response?.data?.result?.invoice_id > 0) {
      await loadData();
      Swal.fire(
        t("invoice number") + " : " + response?.data?.result?.invoice_number
      );

      await props.loadData(0);
    } else {
      success(t("submission_error_title"));
    }

    paramUseModal.closeModal();
  };
  const save = async () => {
    if (rateIds.length === 0) {
      error(t("the_list_is_empty"));
      return;
    }
    confirm({
      useModal: paramUseModal,
      title: "confirmation",
      params: {
        rateIds: rateIds,
        token: token,
        dueAt: nextDate(new Date(), 7),
      },
      messageConfirm: t("are_you_sure_to_add_the_invoice"),
      handleChange: createInvoice,
    });
  };
  const excel = async (event) => {
    if (rateIds.length === 0) {
      error(t("the_list_is_empty"));
      return;
    }
    window.wait(1);
    const columnsExcel = [
      { label: "A", width: "25" },
      { label: "B", width: "25" },
      { label: "C", width: "25" },
      { label: "D", width: "25" },
      { label: "E", width: "15" },
      { label: "F", width: "15" },
      { label: "G", width: "5" },
    ];
    const headerExcel = {
      A: "N°",
      B: "service",
      C: "name",
      D: "checkin",
      E: "checkout",
      F: "price",
      G: "",
    };

    let data = [headerExcel];
    var total_excel = 0;
    bookingList.forEach((row) => {
      total_excel += float(row.amount);
      data.push({
        A: row.booking_number,
        B: t(row.service),
        C: row.product_name,
        D: row.checkin,
        E: row.checkout,
        F: row.amount,
        G: row.currency,
      });
    });
    data.push({
      A: "",
      B: "",
      C: "",
      D: "",
      E: "Total",
      F: total_excel,
      G: "",
    });
    var titleName = "proforma";
    await downloadExcel("proforma", titleName, data, columnsExcel);
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      setMaxAmount();
    }
  };

  function ToolBar({ element }) {
    switch (element) {
      case "refresh":
        return (
          <Button className="right-button" onClick={refresh}>
            {t("refresh")}
          </Button>
        );

      case "save":
        return (
          <Button className="right-button" onClick={save}>
            {t("save")}
          </Button>
        );

      case "excel":
        return (
          <Button className="right-button" onClick={excel}>
            {t("Excel")}
          </Button>
        );

      case "max-amount":
        return (
          <InputGroup size="sm">
            <Form.Control
              className="form-control-input-group"
              type="number"
              id="max-amount"
              defaultValue="0"
              onKeyDown={handleKeyDown}
            />
            <Button
              className="right-button-2"
              onClick={setMaxAmount}
              type="button"
            >
              {t("valider")}
            </Button>
          </InputGroup>
        );

      case "totalinput":
        return (
          <>
            <Form as={"h4"} className="text-right fw-bold p-2">
              {money(total)}
            </Form>
          </>
        );

      default:
        break;
    }
  }

  return (
    <div>
      <SplitPane
        split="vertical"
        minSize={"20%"}
        maxSize={"20%"}
        defaultSize={"20%"}
      >
        <div className="simulationDiv">
          <NewInvoiceForm
            dateFrom={dateFrom}
            dateTo={dateTo}
            onChangeDate={onChangeDate}
            setSelectedService={setSelectedService}
            selectedServices={selectedService}
            loadData={loadData}
          />
        </div>
        <div className="statisticsDiv">
          <IToolbar
            navItems={navItems}
            composite={{
              refresh: <ToolBar element="refresh" />,
              save_invoice: <ToolBar element="save" />,
              refresh_max_amount: <ToolBar element="max-amount" />,
              xsl_new_invoice: <ToolBar element="excel" />,
              totalinvoice: <ToolBar element="totalinput" />,
            }}
            moduleName={t("provider")}
          />
             <div class="tableFixHead">
          
            <table>
            <TableHeader header={header} />
                <tbody>
                  <Listing
                    bookingList={bookingList}
                    header={header}
                    setTotal={setTotal}
                  />
                </tbody>
              </table>
          </div>
        </div>
      </SplitPane>
    </div>
  );
};

export default NewInvoice;

const Printfiled = ({ item, filed, solde }) => {
  switch (filed) {
    case "booking_number":
      return <>{item[filed]}</>;
    case "amount":
      return money(item[filed]);
    case "solde":
      return money(solde);
    default:
      return item[filed];
  }
};

const Listing = (props) => {
  const bookingList = props.bookingList;
  const header = props.header;

  var dataBody = [];
  var solde = 0;

  bookingList.forEach(function (item, index) {
    solde += float(item.amount);
    dataBody.push(
      <tr
        id={"rate-" + item.rate_id}
        className="rate-child"
        key={"rate-" + item.rate_id}
      >
        {header.map((head, i) => (
          <td
            key={head.filed + "-" + item.rate_id}
            className="cell100"
            style={{
            
              textAlign: head.align,
            }}
          >
            <Printfiled item={item} filed={head.filed} solde={solde} />
          </td>
        ))}
      </tr>
    );
  });
  props.setTotal(solde);

  return <>{dataBody}</>;
};
